export const ccpKeyToProductId = {
    "d8a847a4-cde4-4c50-8ea1-dc3d4193214f": "jira",
    "6aab3f4e-cc71-474d-8d28-abef8b057808": "confluence",
    "de63a248-1f93-46ed-b6ea-ab8e38af1c88": "jsm",
    "a6f908c8-709c-45f4-9e2d-eca25b93b94a": "jpd"
} as const;

export type CCPKeyToProductIdType = typeof ccpKeyToProductId;
export type CCPKey = keyof CCPKeyToProductIdType;

export const NUM_DISPLAY_RECOMMENDATIONS = 2;
